import { languages } from '../constants';
import { Language } from '../types';

const isLanguage = (language: unknown): language is Language => {
	return languages.includes(language as Language);
}

export default isLanguage;